export default __webpack_public_path__ + "static/media/83g.31552802.svg";